import Repository from "@/services/Repository";
import store from "@/store";
import router from "@/router";

Repository.interceptors.response.use(
  response => response,
  error => {
    if ([403].includes(error.response.status)) {
      const { name, path, hash } = router.currentRoute;
      window.localStorage.setItem(
        "redirect_route",
        JSON.stringify({ name, path, hash })
      );
      window.location.href = store.state.login_url;
    }
    return Promise.reject(error);
  }
);

export default {
  verify(token) {
    return Repository.get("/verify/", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  getSkills(character_id) {
    return Repository.get(`/latest/characters/${character_id}/skills`, {
      headers: {
        Authorization: `Bearer ${store.state.access_token}`
      }
    });
  },
  getPortrait(character_id) {
    return Repository.get(`/latest/characters/${character_id}/portrait`).then(
      ({ data }) => data.px256x256
    );
  },
  getFittings() {
    return Repository.get(
      `/latest/characters/${store.state.character_id}/fittings`,
      {
        headers: {
          Authorization: `Bearer ${store.state.access_token}`
        }
      }
    );
  },
  deleteFitting(fitting_id) {
    return Repository.delete(
      `/latest/characters/${store.state.character_id}/fittings/${fitting_id}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.access_token}`
        }
      }
    );
  },
  getImplants() {
    return Repository.get(
      `/latest/characters/${store.state.character_id}/implants`,
      {
        headers: {
          Authorization: `Bearer ${store.state.access_token}`
        }
      }
    );
  },
  getLoyalty() {
    return Repository.get(
      `/latest/characters/${store.state.character_id}/loyalty/points`,
      {
        headers: {
          Authorization: `Bearer ${store.state.access_token}`
        }
      }
    );
  }
};
